/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable complexity */
import RelatedTestAux from '@/views/shared/related-test-aux/index.vue';
import AccountInfoAml from '@/views/accounts/accounts-details/account-info-aml/index.vue';
const CrsData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/crs-data');
const RegistralesPjData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/registrales-pj-data');
const FatcaData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/fatca-data');
const GdprData = () => import(/* webpackChunkName: "Interveners" */ '@/views/interveners-details/intervener-aux/gdpr');

export default {
    name: 'IntervenersAux',
    components: {
        CrsData,
        RegistralesPjData,
        FatcaData,
        GdprData,
        RelatedTestAux,
        AccountInfoAml
    },
    /**
     * @override
     */
    data() {
        return {
            collapsed: true,
            intervenerKyc: [],
            intervenerGdpr: [],
            intervenerRegistrales: {},
            intervenerRegistralesKey: new Date().getUTCMilliseconds(),
            intervenerCrs: [],
            intervenerCrsKey: new Date().getUTCMilliseconds(),
            intervenerFatca: {},
            intervenerFatcaKey: new Date().getUTCMilliseconds()
        };
    },
    props: {
        id: {
            type: String,
            required: false
        },
        intervener: {
            type: Object,
            required: false
        },
        intervenerRisk : {
            type: Array,
            required: false
        }
    },
    methods: {
        /**
         * Obtenemos la información del interviniente
         */
        fetchData() {
            this.uuid_intervener = this.id || this.$route.params.uuid;
            this.loadIntervenerKyc(this.uuid_intervener);
            this.loadIntervenerLegal(this.uuid_intervener);
            this.loadIntervenerCrs(this.uuid_intervener);
            this.loadIntervenerFatca(this.uuid_intervener);
            this.loadIntervenerGdpr(this.uuid_intervener);
        },

        /**
         * Obtenemos la información del interviniente
         * @param {String} uuid ID del interviniente
         */
        loadIntervenerKyc(uuid) {
            Promise.all([this.$intervenersService.getIntervenerKyc(uuid)])
                .then(res => {
                    const allTests = res[0].data.intervener_kyc[0].tests || [];

                    // Encontrar el test más reciente basado en test_created_on
                    const latestTest = allTests.reduce((latest, current) => {
                        if (!latest.test_created_on || (new Date(current.test_created_on) > new Date(latest.test_created_on))) {
                            return current;
                        }
                        return latest;
                    }, {});

                    // Verificar si el test más reciente tiene respuestas y ordenarlas
                    if (latestTest && latestTest.responses) {
                        latestTest.responses = latestTest.responses.sort((a, b) => a.order_question - b.order_question);
                    }

                    this.intervenerKyc = latestTest ? [latestTest] : [];
                });
        },

        getTableHeaders(answerObj) {
            if (!answerObj || typeof answerObj !== 'object') return [];
        
            const headers = [];
        
            // Extraer los encabezados de la primera fila
            const firstRow = Object.values(answerObj)[0];
            if (Array.isArray(firstRow.value)) {
                firstRow.value.forEach(item => {
                    headers.push({
                        key: item.key, 
                        label: item.response_text || item.key
                    });
                });
            }
        
            return headers;
        },
        
        getTableRows(answerObj) {
            if (!answerObj || typeof answerObj !== 'object') return [];
        
            const rows = [];
        
            // Iterar sobre cada fila en el objeto answerObj
            Object.values(answerObj).forEach(rowData => {
                if (Array.isArray(rowData.value)) {
                    const row = {};
        
                    // Iterar en cada item en 'value' para construir la fila si tiene datos
                    rowData.value.forEach(item => {
                        if (item.value) { // Solo agregar el campo si tiene valor
                            row[item.key] = item.value;
                        }
                    });
        
                    // Agregar la fila solo si tiene datos
                    if (Object.keys(row).length > 0) {
                        rows.push(row);
                    }
                }
            });
        
            return rows;
        },

        extractAnswerValues(answer) {
            if (answer === null || answer === undefined || answer === '') return [];

            if (Array.isArray(answer)) return answer.flatMap(item => this.extractAnswerValues(item));

            if (typeof answer === 'object') {
                if (Object.prototype.hasOwnProperty.call(answer, 'value')) {
                    return this.extractAnswerValues(answer.value);
                }

                if (Object.prototype.hasOwnProperty.call(answer, 'answer')) {
                    return this.extractAnswerValues(answer.answer);
                }

                return [];
            }

            return [String(answer)];
        },

        formatAnswerValue(answer) {
            return this.extractAnswerValues(answer).join(', ');
        },

        getConditionalAnswerValues(answerObj) {
            if (!answerObj || typeof answerObj !== 'object') return [];

            const answerValues = this.extractAnswerValues(answerObj.answer);
            const nestedValues = this.extractAnswerValues(answerObj.nested);

            if (nestedValues.length === 1) {
                const baseAnswer = this.formatAnswerValue(answerObj.answer);
                return [baseAnswer ? `${baseAnswer}: ${nestedValues[0]}` : nestedValues[0]];
            }

            if (nestedValues.length > 1) {
                const baseAnswer = this.formatAnswerValue(answerObj.answer);
                return baseAnswer ? [baseAnswer, ...nestedValues] : nestedValues;
            }

            return answerValues;
        },

        getAnswerDisplayValues(answer) {
            if (!answer || !answer.answer_obj) return [];

            if (answer.field_type === 'radio-conditional' || answer.field_type === 'select-conditional') {
                return this.getConditionalAnswerValues(answer.answer_obj);
            }

            return this.extractAnswerValues(answer.answer_obj.answer);
        },

        shouldRenderAnswerAsList(answer) {
            return this.getAnswerDisplayValues(answer).length > 1;
        },

        getFormattedAnswer(answer) {
            return this.getAnswerDisplayValues(answer).join(', ');
        },

        /**
         * Obtenemos la información del interviniente
         * @param {String} uuid ID del interviniente
         */
        loadIntervenerLegal(uuid) {
            Promise.all([this.$intervenersService.getIntervenerLegal(uuid)])
                .then(res => {
                    this.intervenerRegistrales = res[0].data.interveners_business.length ? res[0].data.interveners_business[0] : {};
                    this.intervenerRegistralesKey = new Date().getUTCMilliseconds();
                });
        },
        /**
         * Obtenemos la información del interviniente
         * @param {String} uuid ID del interviniente
         */
        loadIntervenerCrs(uuid) {
            Promise.all([this.$intervenersService.getIntervenerCrs(uuid)])
                .then(res => {
                    this.intervenerCrs = res[0].data.intervener_crs || [];
                    this.intervenerCrsKey = new Date().getUTCMilliseconds();
                });
        },
        /**
         * Format info to correct display
         * @param {Number} indexTest index of test
         * @param {Number} indexAnswer index of answer
         * @return {Object} intervenerCRS object
         */
        aw(indexTest, indexAnswer) {
            return this.intervenerKyc[indexTest].responses[indexAnswer].answer.responses;
        },
        /**
         * Return translated answer
         * @param {String} answer answer key
         * @return {String} the translation
         */
        at(answer) {
            return answer ? this.$t(`polls.responses.${answer}`) : '';
        },
        /**
         * Return translated question
         * @param {Number} indexTest index of test
         * @param {Number} indexAnswer index of answer
         * @return {Object} intervenerCRS object
         */
        qt(indexTest, indexAnswer) {
            return this.$t(`polls.questions.${this.intervenerKyc[indexTest].responses[indexAnswer].question}`);
        },

        /**
         * Obtenemos la información del interviniente
         * @param {String} uuid ID del interviniente
         */
        loadIntervenerFatca(uuid) {
            Promise.all([this.$intervenersService.getIntervenerFatca(uuid)])
                .then(res => {
                    this.intervenerFatca = res[0].data.intervener_fatca.length ? res[0].data.intervener_fatca[0] : {};
                    this.intervenerFatca.key = new Date().getUTCMilliseconds();
                });
        },
        /**
         * Obtenemos la información del interviniente
         * @param {String} uuid ID del interviniente
         */
        async loadIntervenerGdpr(uuid) {
            try {
                const res = await this.$intervenersService.getIntervenerGdpr(uuid);
                const gdprData = res?.data?.interveners_gdpr || [];

                this.intervenerGdpr = gdprData.map(item => ({
                    ...item,
                    updated_on: item.updated_on
                        ? this.$moment(item.updated_on).format('DD-MMM-YYYY')
                        : ''
                }));
            } catch (err) {
                console.error('Error al cargar GDPR:', err);
                this.$toast.error('Error', 'Error al cargar los datos de GDPR');
            }
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.fetchData();
    }
};
